// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"b3b4a933","586":"71cdbb14"}[chunkId] + ".chunk.css";
};